export const SERVICE_BLOCKS = [
    {
        slug: "maintenance",
        title: "Maintenance",
        summary:
            "Planned and reactive support for the electrical and mechanical systems industrial operations run on — and methodical fault-finding when something stops.",
        items: [
            "Industrial electrical maintenance and fault-finding",
            "Industrial mechanical maintenance and fault-finding",
            "Planned preventive maintenance",
            "Reactive maintenance support",
        ],
        boundary:
            "Industrial environments only. Work outside demonstrated competence is declined or referred.",
    },
    {
        slug: "controls",
        title: "Controls and rotating equipment",
        summary:
            "Diagnostics and maintenance for the automation and rotating equipment at the centre of production.",
        items: [
            "PLC fault-finding and diagnostics",
            "Motors and variable-frequency drives",
            "Conveyor and automated-equipment maintenance",
            "Pumps and industrial equipment support, within demonstrated competence",
        ],
        boundary:
            "Support is provided within demonstrated competence; specialist work beyond that boundary is referred.",
    },
    {
        slug: "improvement",
        title: "Improvement",
        summary: "Finding why failures happen — and stopping them repeating.",
        items: ["Root-cause analysis", "Maintenance improvement", "Engineering technical support"],
        boundary:
            "Analysis and recommendations are delivered against a defined scope; implementation, where needed, is agreed separately.",
    },
    {
        slug: "advisory",
        title: "Advisory",
        summary: "Independent guidance on how maintenance is organised, measured and digitised.",
        items: ["Maintenance consultancy", "CMMS and maintenance-workflow advisory"],
        boundary:
            "Advisory work is independent of any product; subsequent delivery, if any, is scoped separately.",
    },
    {
        slug: "installation",
        title: "Installation support",
        summary: "Electrical and mechanical installation support in industrial settings.",
        items: ["Electrical installation support", "Mechanical installation support"],
        boundary:
            "Undertaken only where appropriately qualified and authorised for the specific work. Work falling outside that authorisation is declined.",
    },
];

export const ENQUIRY_STEPS = [
    {
        title: "Outline the requirement",
        text: "Use the enquiry form, email, phone, or book a 30-minute call. Describe the equipment or systems involved, the fault or the goal, and the type of site.",
    },
    {
        title: "Response within two working days",
        text: "Every enquiry receives a reply within two working days, with any clarifying questions needed to scope it properly.",
    },
    {
        title: "Scope before work",
        text: "If there is a fit, scope, competence boundaries and terms are agreed before any work begins.",
    },
];

export const FAQS = [
    {
        q: "Which areas do you cover?",
        a: "Nachi Eng Ltd is based in Southend-on-Sea, Essex, and works across London, Essex and the wider South East. Projects elsewhere in the UK are considered by agreement.",
    },
    {
        q: "How quickly will I hear back?",
        a: "Every enquiry receives a response within two working days.",
    },
    {
        q: "Do you offer emergency or out-of-hours callout?",
        a: "No. Availability is agreed per engagement, and the standing commitment is a response to enquiries within two working days.",
    },
    {
        q: "Who carries out the work?",
        a: "Nachi Eng Ltd is built around one qualified engineer — founder Godswill C. Iweajunwa, BEng (Hons) Electrical & Electronic Engineering (First Class), MIET, and an 18th Edition electrical qualification. You deal directly with the person who does the work.",
    },
    {
        q: "What should I include in an enquiry?",
        a: "The equipment or systems involved, the fault symptoms or the improvement goal, the type of site, and any timescales you are working to.",
    },
    {
        q: "What is Nachi CMMS?",
        a: "Nachi CMMS is a computerised maintenance management system currently in development at Nachi Eng Ltd. It is informed by hands-on industrial maintenance experience and demonstrated privately using sample data. See the Nachi CMMS page for details.",
    },
];
